import AlertsTable from "./AlertsTable";

const Alerts = () => (
  <div className="bg-white rounded-lg p-5">
    <AlertsTable />
  </div>
);

export default Alerts;
